import styles from "./visualization.module.css";
import parallax from "../parallax";
import { useRef, useEffect } from "react";
import DOMPurify from "dompurify";

const Visualization = ({ textData ,language}) => {
  const textBox = useRef(null);
  useEffect(() => {
    parallax(
      {
        trigger: textBox.current,
        start: "top bottom",
        end: "top top",
        scrub: true,
      },
      textBox.current
    );
  }, []);
  return (
    <div className={styles.ctn}>
      <div className={styles.imgBox} data-parallax="true">
        <video
          autoPlay
          loop
          playsInline
          muted
          preload="true"
          src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-10${language === 'cn' ? '' : '-en'}.mp4`}
          poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-10-poster${language === 'cn' ? '' : '-en'}.jpg`}
        ></video>
      </div>
      <div className={styles.textBox} ref={textBox}>
        <h2
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text19"]),
          }}
        ></h2>
        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text20"]),
          }}
        ></h5>
      </div>
    </div>
  );
};

export default Visualization;
